import * as email from './email.js';

export default {
    email,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Email
    window.EQLAPP.EMAIL = window.EQLAPP.EMAIL || {};
    Object.entries(email).forEach(([key, value]) => {
        window.EQLAPP.EMAIL[key] = value;
    });

}